<template>
  <div class="gf_price-info-discount">
    <template v-if="hasCoupon">
      {{ promotionCouponName }}
    </template>
    <template v-else>
      <div v-if="bfcm" class="gf_price-promotion-notice" v-html="$t('dataNewPlan.promotion.dateTime')"></div>
      <template v-else>
        <span v-html="$t(promotionCode)"></span>
        {{ promotionNotExpires > 0 ? $t('pricing.promotionDaysLeft', { promotion: promotionNotExpires }) : "" }}
      </template>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import { BFCM } from "@/contants/plan";

export default {
  name: "Promotion",
  props: {
    promotion: {},
    coupon: {},
  },
  computed: {
    hasCoupon() {
      return this.coupon?.discount
    },
    bfcm() {
      return this.promotionCode === BFCM
    },
    hasPromotion() {
      return this.promotion?.code
    },
    promotionCode() {
      return this.promotion?.code
    },
    promotionNotExpires() {
      const endDate = moment(this.promotion?.endDate)
      const currentDate = moment(Date.now())
      return endDate.diff(currentDate, 'days')
    },
    promotionCouponName() {
      if (this.coupon?.unit === "%") {
        return this.$t('pricing.promotionCouponUnit', { promotion: this.coupon?.discount });
      }

      return this.$t('pricing.promotionCouponPrice', { promotion: this.coupon?.discount });
    }
  }
};
</script>
